import { Chambers } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Committee` endpoint class.
 */
export interface ICommitteePathParameters {
  /** The chamber of congress where the committee resides. */
  chamber?: Chambers

  /**
   * The number of the session of congress. For example, `117` for the 117th
   * Congress.
   */
  congress?: number

  /** The identifier of the committee. */
  committeeCode?: number
}
